<template>
  <v-container>
    <v-layout text-center wrap>
      <v-flex xs12>
        <v-container class="fill-height" fluid>
          <v-row align="center" justify="center">
            <v-col cols="12" sm="8" md="4">
              <v-card class="elevation-12">
                <v-toolbar color="primary" dark>
                  <v-toolbar-title>{{$t("RegistrationPage.toolbarTitle")}}</v-toolbar-title>
                  <div class="flex-grow-1"></div>
                </v-toolbar>
                <v-card-text>
                  <v-form v-model="valid">
                    <v-text-field
                        :label="$t('RegistrationPage.loginLabel')"
                        name="login"
                        prepend-icon="mdi-account"
                        type="email"
                        v-model="email"
                        :rules="[validRequired, validEmail]"
                    ></v-text-field>

                    <v-text-field
                        :append-icon="PasswShow ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="PasswShow ? 'text' : 'password'"
                        @click:append="PasswShow = !PasswShow"
                        id="password"
                        :label="$t('RegistrationPage.PasswordLabel1')"
                        name="password"
                        prepend-icon="mdi-lock"
                        v-model="password"
                        :rules="[validRequired, validLength8chars]"
                    ></v-text-field>

                    <v-text-field
                        :append-icon="PasswShow ? 'mdi-eye' : 'mdi-eye-off'"
                        :type="PasswShow ? 'text' : 'password'"
                        @click:append="PasswShow = !PasswShow"
                        id="password2"
                        :label="$t('RegistrationPage.PasswordLabel1')"
                        name="password"
                        prepend-icon="mdi-lock"
                        v-model="confirmPassword"
                        :rules="[validRequired, validLength8chars]"
                    ></v-text-field>
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <div class="flex-grow-1"></div>
                  <v-btn :disabled="!valid" color="primary"  @click="btnRegistration()">{{$t("RegistrationPage.btnRegistrationTitle")}}</v-btn>

                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-container>

      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import {mapActions} from "vuex"

export default {
  name:"RegistrationPage",
  data () {
    return {
      email: '',
      password: '',
      confirmPassword: '',
      valid: false,
      PasswShow: false,

    }
  },
  // computed: {
  //   loading () {
  //     return this.$store.getters.loading
  //   }
  // },
  methods: {
    ...mapActions('common',["apiBackendRegister"]),
    btnRegistration(){
      this.apiBackendRegister({login:this.email,password:this.password})
    },

    validRequired(v) {
      return !!v || this.$t("RegistrationPage.validRequiredTitle")
    },

    validLength8chars(v) {
      return v.length >= 8 || this.$t("RegistrationPage.validLength8charsTitle")
    },

    validEmail(v) {
      return /.+@.+\..+/.test(v) || this.$t("RegistrationPage.validEmailTitle")
    },

    passwordMatch(){
      return this.password === this.confirmPassword || this.$t("RegistrationPage.validPasswordMatchTitle")
    },

  },
  created() {
  }
}

</script>
